module.exports = __webpack_public_path__ + "static/media/bill-to-ship-to.313b03b4.png";